module.exports = __webpack_public_path__ + "fonts/DINPro-CondBlackIta.70c3ca4d.otf";